import React from "react";
import Modal from "../ui/Modal";
import { ModalActionsProps } from "./ModalActions";
import { ModalActions } from "./ModalActions";
import "./StandardModal.css";

export interface StandardModalProps {
  title: string;
  onClose: () => void;
  maxWidth?: string;
  children: React.ReactNode;
  /** Optional standardized action buttons */
  actions?: ModalActionsProps;
}

/**
 * Standard modal shell that wraps the base Modal and adds optional
 * standardized action buttons. Use for add/edit/view modals.
 */
export function StandardModal({
  title,
  onClose,
  maxWidth = "500px",
  children,
  actions,
}: StandardModalProps) {
  return (
    <Modal title={title} onClose={onClose} maxWidth={maxWidth}>
      <div className="standard-modal-body">
        {children}
        {actions && <ModalActions {...actions} />}
      </div>
    </Modal>
  );
}
